import { Chip, Stack, Typography } from "@mui/material";
import { ICustomer } from "mobx-stores/_models/customers/customer";
type CustomerDealingAndActiveInfoProps = {
  customer: ICustomer;
};
export const CustomerDealingAndActiveInfo = ({
  customer,
}: CustomerDealingAndActiveInfoProps) => {
  return (
    <Stack direction={"row"} spacing={1} alignItems={"center"}>
      <Typography>{customer.dealingName || ""}</Typography>
      {customer.isDisabled && (
        <Chip
          variant="outlined"
          label={"Ngưng SX"}
          color="error"
          size="small"
        ></Chip>
      )}
    </Stack>
  );
};
